module.exports = __webpack_public_path__ + "static/media/recruit_480_business.7b807e55.png";